import styled from "styled-components";

export const TotalBalanceBlock = ({ block }: IProps) => {
	if (!block) {
		return <></>;
	}
	return (
		<>
			<StyledComponent className="balanceBlock">
				<div className="action">Донат</div>
				<div className="balance">
					{block?.donation?.amount.toFixed(2) || 0} /{" "}
					{block?.donation?.fee.toFixed(2) || 0}
				</div>
			</StyledComponent>
			<StyledComponent className="balanceBlock">
				<div className="action">Собрано</div>
				<div className="balance">
					{block?.gather?.amount.toFixed(2) || 0} /{" "}
					{block?.gather?.fee.toFixed(2) || 0}
				</div>
			</StyledComponent>
			<StyledComponent className="balanceBlock">
				<div className="action">Выплачено</div>
				<div className="balance">
					{block?.payout?.amount.toFixed(2) || 0} /{" "}
					{block?.payout?.fee.toFixed(2) || 0}
				</div>
			</StyledComponent>
			<StyledComponent className="balanceBlock">
				<div className="action">Ресурс</div>
				<div className="balance">
					{block?.resource?.amount.toFixed(2) || 0} /{" "}
					{block?.resource?.fee.toFixed(2) || 0}
				</div>
			</StyledComponent>
		</>
	);
};
const StyledComponent = styled.div`
	display: flex;
	justify-content: space-between;

	padding: 0.5rem;
`;

interface IProps {
	block?: { [key: string]: any };
}
